
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28941",
  depVersions: {
  "payments-ui-app": "static-1.28941",
  "apollo-dlb": "static-3.98",
  "bend-plugin-arboretum": "static-1.2093",
  "client-types": "static-1.524",
  "crm_data": "static-4.93367",
  "data-fetching-client": "static-1.10175",
  "emoji-mart": "static-3.10",
  "enviro": "static-4.529",
  "foundations-components": "static-1.8852",
  "foundations-components-legacy": "static-1.1877",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6131",
  "hs-test-utils": "static-1.8583",
  "hub-http": "static-1.6745",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12029",
  "I18n": "static-7.1724",
  "jasmine-runner": "static-1.6998",
  "quartz": "static-1.7764",
  "raven": "static-3.6435",
  "react-dlb": "static-1.97",
  "react-stripe-js": "static-1.124",
  "react-utils": "static-2.5719",
  "reselect": "static-3.20",
  "stripe-js": "static-1.123",
  "ui-components-test-utils": "static-1.6166",
  "UIComponents": "static-3.8975",
  "usage-tracker-public": "static-1.7695",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38174",
  "cssUtils": "static-1.1163",
  "customer-data-objects": "static-1.8255",
  "FireAlarmUi": "static-1.4928",
  "foundations-assets": "static-1.5429",
  "foundations-theming": "static-1.5041",
  "graphql": "static-1.96",
  "hs-browser-apis": "static-1.18",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12336",
  "icons": "static-2.716",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3416",
  "payments-checkout-lib": "static-1.864",
  "property-translator": "static-1.5915",
  "quartz-config": "static-1.1542",
  "quartz-core": "static-1.6983",
  "quartz-i18n": "static-1.1439",
  "quartz-routing": "static-1.1194",
  "quartz-tracking": "static-1.1143",
  "react": "static-7.206",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17279",
  "react-select-plus": "static-1.121",
  "react-virtualized": "static-2.115",
  "redux": "static-4.81",
  "redux-thunk": "static-2.88",
  "redux-toolkit": "static-1.85",
  "ReduxMessenger": "static-2.10912",
  "rpc-client-utils": "static-1.5206",
  "sanitize-text": "static-1.8697",
  "SharedI18nStrings": "static-1.191",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.521",
  "superstore": "static-1.5295",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11687",
  "ui-images": "static-2.1296",
  "usage-tracker-core": "static-1.7734",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4041",
  "quartz-webpack": "static-1.3988",
  "bend-plugin-quartz-routing": "static-1.842",
  "bender-build-tools": "static-1.3648",
  "crm_universal": "static-1.22816",
  "customer-data-email": "static-1.18739",
  "customer-data-ui-utilities": "static-1.10373",
  "dispatcher": "static-1.151",
  "frontend-preferences-client": "static-1.8463",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8298",
  "quick-fetch": "static-1.4267",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5121",
  "floating-ui": "static-1.71",
  "foundations-theming-specialty": "static-1.2757",
  "framer-motion": "static-1.87",
  "hs-story-utils": "static-1.9965",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.122",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3270",
  "ui-fonts": "static-1.1291",
  "HeadJS": "static-2.838",
  "hs-test-utils-bend-plugin": "static-1.3694",
  "msw": "static-1.106",
  "msw-config": "static-1.43",
  "testing-library": "static-1.168",
  "hs-locale-management": "static-1.442",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4845",
  "foundations-components-test-utils": "static-1.6335",
  "ui-addon-draggable": "static-3.5292",
  "commerce-billing-lib": "static-1.20627",
  "commerce-shared-components-lib": "static-1.19700",
  "commerce-tools-ui-lib": "static-1.11437",
  "crm-message-bus": "static-1.44261",
  "customer-data-objects-ui-components": "static-1.13576",
  "customer-data-properties": "static-1.53258",
  "growth-payments-core": "static-1.26634",
  "ui-addon-iframeable": "static-1.9620",
  "usage-tracker": "static-1.7884",
  "usage-tracker-container": "static-1.7874",
  "sassPrefix": "static-1.428",
  "inbound-db-properties-service-client": "static-1.4190",
  "foundations-theming-base": "static-1.4026",
  "bend-plugin-foundations-theming": "static-1.3524",
  "stylex": "static-1.49",
  "opentelemetry-fe-types": "static-1.340",
  "hub-http-janus": "static-1.920",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.619",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.715",
  "quartz-auth": "static-1.1439",
  "quartz-head": "static-1.1429",
  "quartz-test": "static-1.1439",
  "trellis-components": "static-1.3289",
  "usage-tracker-session-replay": "static-1.5570",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.242",
  "web-vitals": "static-1.22",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.616",
  "chirp-fetch": "static-1.2440",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5008",
  "FormUrlGenerator": "static-2.5254",
  "sequences-lib": "static-1.8875",
  "apollo-link-hub-http": "static-2.5129",
  "FileManagerCore": "static-1.40441",
  "FileManagerLib": "static-1.40582",
  "hubspot-apollo-client": "static-1.5416",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.798",
  "timezone-utils": "static-2.5766",
  "ui-gdpr-components": "static-1.10659",
  "react-dnd-compat": "static-1.5150",
  "stylex-utils": "static-1.191",
  "trellis-theming": "static-1.1585",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.86",
  "avatar-components": "static-1.3028",
  "crm-command-handler-types": "static-1.199",
  "hs-resources": "static-1.736",
  "onboarding-scopes": "static-1.6992",
  "pulse": "static-1.1210",
  "upgrade-components-lib": "static-1.798",
  "utility-belt": "static-1.3075",
  "zustand": "static-1.93",
  "batch-promise": "static-1.2091",
  "customer-data-associations": "static-1.7884",
  "customer-data-property-utils": "static-1.8599",
  "customer-data-tracking": "static-1.7411",
  "framework-data-table": "static-2.12952",
  "object-builder-ui-client": "static-1.50227",
  "payments-enrollment-embed-lib": "static-1.24409",
  "stripe-embedded-components": "static-1.8339",
  "ui-addon-opt": "static-4.8977",
  "ai-components-ui-library": "static-1.10135",
  "customer-data-rte": "static-1.34006",
  "cv-backend-services": "static-1.1622",
  "file-manager-components": "static-1.24942",
  "growth-onboarding-confetti": "static-1.3596",
  "growth-onboarding-empty-states": "static-1.6632",
  "hubspot-prosemirror": "static-1.19408",
  "InboxConnectUtils": "static-4.15962",
  "payment-link-components": "static-1.24593",
  "payments-post-enroll-local-storage-lib": "static-1.5640",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.83",
  "quotes-client-types": "static-1.39299",
  "react-colorpicker": "static-2.10749",
  "ui-addon-upgrades": "static-9.18611",
  "ui-addon-video-player": "static-1.9162",
  "user-context": "static-1.5598",
  "atom": "static-1.5614",
  "reference-resolvers": "static-1.8726",
  "calling-global-api": "static-1.66528",
  "calling-internal-common": "static-1.31863",
  "calling-lifecycle-internal": "static-1.67910",
  "calling-lifecycle-messages": "static-1.60202",
  "commerce-products-lib": "static-1.11101",
  "conditional-properties-service-client": "static-1.4151",
  "crm-index-visualization-core": "static-1.4852",
  "crm-links": "static-1.6868",
  "crm-pipelines-api-client-types": "static-1.4484",
  "customer-data-properties-shared-msw-handlers": "static-1.10336",
  "data-agent-utils": "static-1.1070",
  "data-token-picker": "static-1.17228",
  "external-options-client-types": "static-1.4478",
  "formula-editor": "static-1.15086",
  "google-libphonenumber": "static-1.53",
  "inbound-db-meta-service-client": "static-1.3810",
  "inbounddb-objects-service-types": "static-1.4555",
  "meetings-icalendar-utils-lib": "static-1.1175",
  "multi-currency-client-types": "static-1.4049",
  "pipeline-validation-client-types": "static-1.4322",
  "property-value-citations": "static-1.3872",
  "react-tinymce": "static-1.56380",
  "reference-resolvers-lite": "static-1.8653",
  "rich-text-lib": "static-1.20650",
  "smart-data-capture-core": "static-1.622",
  "tiered-pricing": "static-1.2392",
  "tinymce-config": "static-2.55506",
  "tinymce-plugins": "static-1.58620",
  "tinymce-themes": "static-1.57476",
  "topics-actions-lib": "static-1.734",
  "trellis-ext-i18n": "static-1.1484",
  "trial-components-library": "static-1.14487",
  "ui-addon-emoji-picker": "static-1.10404",
  "ui-addon-form-validation": "static-1.11353",
  "laboratory-lib": "static-3.7689",
  "seat-types-lib": "static-1.1178",
  "magpie-lib": "static-1.5963",
  "navigation-messaging": "static-1.8659",
  "ts-schema": "static-1.4433",
  "opentelemetry-web": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.11009",
  "hubspotter-http-shared-msw-handlers": "static-1.11007",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "amplitude-session-replay-browser": "static-1.80",
  "sequences-client-types-lib": "static-1.8732",
  "audio-components": "static-1.6654",
  "breeze-artifacts-sdk": "static-1.1223",
  "ContentUtils": "static-1.69625",
  "copilot-toolkit": "static-1.12273",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30153",
  "FileManagerImages": "static-1.38093",
  "html-to-image": "static-1.68",
  "immerable": "static-1.4685",
  "ui-universal-auth": "static-1.9868",
  "urlinator": "static-1.5057",
  "video-components": "static-1.14560",
  "video-data-lib": "static-1.36216",
  "video-embed": "static-1.37050",
  "hubspot-apollo-cache": "static-1.875",
  "trellis-migration-context": "static-1.118",
  "event-emitter": "static-1.1500",
  "fdsr-migration-layer": "static-1.554",
  "framework-builder-read-service-client": "static-1.4374",
  "bend-plugin-pulse": "static-1.713",
  "fast-json-patch": "static-1.77",
  "merchandise-lib": "static-1.291",
  "purchase-motions-components": "static-1.6724",
  "customer-data-reference-ui-components": "static-1.13716",
  "reporting-data": "static-1.69652",
  "tasks-actions-lib": "static-1.571",
  "growth-onboarding-feedback-components": "static-1.7125",
  "growth-onboarding-reliability": "static-1.5623",
  "marketplace-ui-apps-core": "static-1.19695",
  "onboarding-tours": "static-1.17486",
  "stripe-connect-js": "static-1.86",
  "chatspot-core": "static-1.24292",
  "content-assistance-lib": "static-1.8507",
  "draft-content-plugins": "static-1.29258",
  "draft-convert": "static-2.88",
  "draft-extend": "static-3.91",
  "draft-js": "static-5.93",
  "draft-plugins": "static-2.22454",
  "breeze-engine-lib": "static-1.2395",
  "poll-commands": "static-1.4016",
  "video-components-external": "static-1.12558",
  "trellis-story-utils": "static-1.5036",
  "ui-addon-react-router-dom": "static-1.10068",
  "content-media-capture": "static-1.5894",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9636",
  "ui-shepherd-react": "static-3.10827",
  "hub-http-contrib": "static-1.3570",
  "ui-addon-sales-email": "static-1.5748",
  "commerce-tours-lib": "static-1.6954",
  "getting-started-shared-tasks": "static-1.19668",
  "sales-checkout-service-client": "static-1.4062",
  "getting-started-shared-tasks-store": "static-1.18786",
  "onboarding-tours-utils": "static-1.1553",
  "calling-error-reporting": "static-1.31870",
  "shared-worker-versioning": "static-1.11580",
  "calling-usage-tracker": "static-1.7081",
  "conversations-skeleton-state": "static-1.7653",
  "voice-sms-access-library": "static-1.2619",
  "commerce-permissions": "static-1.1323",
  "products-iframe-lib": "static-1.9062",
  "products-ui-components-shared-msw-handlers": "static-1.11391",
  "crm-index-associations-lib": "static-1.6990",
  "sales-views-client-types": "static-1.4798",
  "location-customization-utils-lib": "static-1.10565",
  "data-agent-kit": "static-1.1057",
  "enrichment-settings-lib": "static-1.417",
  "fsm": "static-1.4301",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7344",
  "bark-lib": "static-1.17074",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.109",
  "crm-properties-common-lib": "static-1.6437",
  "react-codemirror": "static-1.11182",
  "tinymce": "static-5.11",
  "interframe": "static-3.5285",
  "tinymce-data": "static-1.41591",
  "layout-dnd-components": "static-1.13323",
  "layout-dnd-utils": "static-1.12298",
  "ui-brand-identity-lib": "static-1.17105",
  "NamespacedHubStyle": "static-2.9407",
  "embedded-academy-lib": "static-1.16222",
  "hubs-service-types": "static-1.1806",
  "navigation-components": "static-1.19332",
  "nest": "static-1.779",
  "nudge-client-utils": "static-1.3516",
  "purchase-motions-api": "static-1.6727",
  "signup-constants": "static-1.20123",
  "idb-keyval": "static-1.58",
  "magpie-types": "static-1.5423",
  "reactive-lib": "static-1.1262",
  "simple-logging-lib": "static-1.3587",
  "nav-meta": "static-1.30969",
  "breeze-engine-core": "static-1.1673",
  "cms-field-types": "static-1.5353",
  "content-icons-ui": "static-1.2524",
  "integrations-lib": "static-1.17567",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.432",
  "unified-auth-core-lib": "static-1.1664",
  "social-insights-client-types": "static-1.23050",
  "outpost": "static-1.4665",
  "persist-promise": "static-1.4248",
  "signup-ui-url-generator": "static-2.8575",
  "reporting-client-types": "static-1.2903",
  "developer-experience-shared-components": "static-1.11085",
  "immutable-less": "static-1.5188",
  "marketplace-ui-client-types": "static-1.18570",
  "marketplace-ui-common": "static-1.21163",
  "ui-addon-integrations-directory-panel": "static-2.8489",
  "ui-extensibility-client-types": "static-1.4458",
  "growth-data-modal": "static-1.6222",
  "growth-onboarding-next-action-utils": "static-1.3105",
  "onboarding-tours-client": "static-1.5701",
  "ui-shepherd-tracker": "static-1.8208",
  "ui-coaching-tips": "static-1.29644",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1373",
  "highlight.js": "static-1.93",
  "content-media-composition-data-lib": "static-1.13698",
  "content-media-compositions": "static-2.17705",
  "media-bridge-lib": "static-1.19734",
  "fix-webm-duration": "static-1.38",
  "notification-sounds": "static-1.4969",
  "calling-orchestration-schema": "static-1.37396",
  "crm-record-cards-service-types": "static-1.3896",
  "highcharts": "static-8.118",
  "storybook-react": "static-1.47",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16778",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69700",
  "layout-data-lib": "static-1.10623",
  "academy-common-lib": "static-1.15683",
  "nudge-custom-function-registry": "static-1.3273",
  "nudge-renderer-utils": "static-1.3592",
  "whisper-core-api": "static-1.7746",
  "flux-actions": "static-1.384",
  "integrations-error-boundary-lib": "static-1.14982",
  "integrations-tracking-lib": "static-1.6168",
  "redux-observable": "static-1.82",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4148",
  "oauth-service-types": "static-1.4676",
  "ai-settings-ui-library": "static-1.8691",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1818",
  "onboarding-data-sync-lib": "static-1.2926",
  "growth-onboarding-next-action-components": "static-1.3133",
  "user-context-client": "static-1.5047",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15914",
  "advanced-menus-lib": "static-1.12642",
  "ExportDialog": "static-6.10914",
  "ui-memberships-settings-lib": "static-1.35335",
  "academy-service-client": "static-1.4233",
  "croppie": "static-2.10",
  "final-form": "static-1.86",
  "SafeStorage": "static-1.4935",
  "trellis-ecosystem": "static-1.7941",
  "universal-page-editor-lib": "static-1.3560",
  "settings-ui-lib": "static-1.13072",
  "simple-data-table": "static-1.3946",
  "meetings-connect-utils-lib": "static-1.8159",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15913",
  "simple-menus-lib": "static-1.17430",
  "crm-record-cards-client": "static-1.237",
  "framework-data-schema-resolvers": "static-1.7432",
  "framework-data-schema-quick-fetch": "static-1.7337"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28941",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2093",
  "client-types": "/client-types/static-1.524",
  "crm_data": "/crm_data/static-4.93367",
  "data-fetching-client": "/data-fetching-client/static-1.10175",
  "emoji-mart": "/emoji-mart/static-3.10",
  "enviro": "/enviro/static-4.529",
  "foundations-components": "/foundations-components/static-1.8852",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1877",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6131",
  "hs-test-utils": "/hs-test-utils/static-1.8583",
  "hub-http": "/hub-http/static-1.6745",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12029",
  "I18n": "/I18n/static-7.1724",
  "jasmine-runner": "/jasmine-runner/static-1.6998",
  "quartz": "/quartz/static-1.7764",
  "raven": "/raven/static-3.6435",
  "react-dlb": "/react-dlb/static-1.97",
  "react-stripe-js": "/react-stripe-js/static-1.124",
  "react-utils": "/react-utils/static-2.5719",
  "reselect": "/reselect/static-3.20",
  "stripe-js": "/stripe-js/static-1.123",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6166",
  "UIComponents": "/UIComponents/static-3.8975",
  "usage-tracker-public": "/usage-tracker-public/static-1.7695",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38174",
  "cssUtils": "/cssUtils/static-1.1163",
  "customer-data-objects": "/customer-data-objects/static-1.8255",
  "FireAlarmUi": "/FireAlarmUi/static-1.4928",
  "foundations-assets": "/foundations-assets/static-1.5429",
  "foundations-theming": "/foundations-theming/static-1.5041",
  "graphql": "/graphql/static-1.96",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12336",
  "icons": "/icons/static-2.716",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3416",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.864",
  "property-translator": "/property-translator/static-1.5915",
  "quartz-config": "/quartz-config/static-1.1542",
  "quartz-core": "/quartz-core/static-1.6983",
  "quartz-i18n": "/quartz-i18n/static-1.1439",
  "quartz-routing": "/quartz-routing/static-1.1194",
  "quartz-tracking": "/quartz-tracking/static-1.1143",
  "react": "/react/static-7.206",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17279",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-virtualized": "/react-virtualized/static-2.115",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.88",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "ReduxMessenger": "/ReduxMessenger/static-2.10912",
  "rpc-client-utils": "/rpc-client-utils/static-1.5206",
  "sanitize-text": "/sanitize-text/static-1.8697",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.521",
  "superstore": "/superstore/static-1.5295",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11687",
  "ui-images": "/ui-images/static-2.1296",
  "usage-tracker-core": "/usage-tracker-core/static-1.7734",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4041",
  "quartz-webpack": "/quartz-webpack/static-1.3988",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.842",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "crm_universal": "/crm_universal/static-1.22816",
  "customer-data-email": "/customer-data-email/static-1.18739",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10373",
  "dispatcher": "/dispatcher/static-1.151",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8463",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8298",
  "quick-fetch": "/quick-fetch/static-1.4267",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5121",
  "floating-ui": "/floating-ui/static-1.71",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2757",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-story-utils": "/hs-story-utils/static-1.9965",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.122",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3270",
  "ui-fonts": "/ui-fonts/static-1.1291",
  "HeadJS": "/HeadJS/static-2.838",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3694",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.43",
  "testing-library": "/testing-library/static-1.168",
  "hs-locale-management": "/hs-locale-management/static-1.442",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4845",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6335",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5292",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20627",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19700",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11437",
  "crm-message-bus": "/crm-message-bus/static-1.44261",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13576",
  "customer-data-properties": "/customer-data-properties/static-1.53258",
  "growth-payments-core": "/growth-payments-core/static-1.26634",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9620",
  "usage-tracker": "/usage-tracker/static-1.7884",
  "usage-tracker-container": "/usage-tracker-container/static-1.7874",
  "sassPrefix": "/sassPrefix/static-1.428",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4190",
  "foundations-theming-base": "/foundations-theming-base/static-1.4026",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3524",
  "stylex": "/stylex/static-1.49",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.340",
  "hub-http-janus": "/hub-http-janus/static-1.920",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.619",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.715",
  "quartz-auth": "/quartz-auth/static-1.1439",
  "quartz-head": "/quartz-head/static-1.1429",
  "quartz-test": "/quartz-test/static-1.1439",
  "trellis-components": "/trellis-components/static-1.3289",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5570",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.242",
  "web-vitals": "/web-vitals/static-1.22",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.616",
  "chirp-fetch": "/chirp-fetch/static-1.2440",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5008",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5254",
  "sequences-lib": "/sequences-lib/static-1.8875",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5129",
  "FileManagerCore": "/FileManagerCore/static-1.40441",
  "FileManagerLib": "/FileManagerLib/static-1.40582",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5416",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.798",
  "timezone-utils": "/timezone-utils/static-2.5766",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10659",
  "react-dnd-compat": "/react-dnd-compat/static-1.5150",
  "stylex-utils": "/stylex-utils/static-1.191",
  "trellis-theming": "/trellis-theming/static-1.1585",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.86",
  "avatar-components": "/avatar-components/static-1.3028",
  "crm-command-handler-types": "/crm-command-handler-types/static-1.199",
  "hs-resources": "/hs-resources/static-1.736",
  "onboarding-scopes": "/onboarding-scopes/static-1.6992",
  "pulse": "/pulse/static-1.1210",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.798",
  "utility-belt": "/utility-belt/static-1.3075",
  "zustand": "/zustand/static-1.93",
  "batch-promise": "/batch-promise/static-1.2091",
  "customer-data-associations": "/customer-data-associations/static-1.7884",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8599",
  "customer-data-tracking": "/customer-data-tracking/static-1.7411",
  "framework-data-table": "/framework-data-table/static-2.12952",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50227",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24409",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8339",
  "ui-addon-opt": "/ui-addon-opt/static-4.8977",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10135",
  "customer-data-rte": "/customer-data-rte/static-1.34006",
  "cv-backend-services": "/cv-backend-services/static-1.1622",
  "file-manager-components": "/file-manager-components/static-1.24942",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3596",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6632",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19408",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15962",
  "payment-link-components": "/payment-link-components/static-1.24593",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5640",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.83",
  "quotes-client-types": "/quotes-client-types/static-1.39299",
  "react-colorpicker": "/react-colorpicker/static-2.10749",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18611",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9162",
  "user-context": "/user-context/static-1.5598",
  "atom": "/atom/static-1.5614",
  "reference-resolvers": "/reference-resolvers/static-1.8726",
  "calling-global-api": "/calling-global-api/static-1.66528",
  "calling-internal-common": "/calling-internal-common/static-1.31863",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67910",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60202",
  "commerce-products-lib": "/commerce-products-lib/static-1.11101",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4151",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4852",
  "crm-links": "/crm-links/static-1.6868",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4484",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10336",
  "data-agent-utils": "/data-agent-utils/static-1.1070",
  "data-token-picker": "/data-token-picker/static-1.17228",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "formula-editor": "/formula-editor/static-1.15086",
  "google-libphonenumber": "/google-libphonenumber/static-1.53",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3810",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4555",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1175",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4049",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4322",
  "property-value-citations": "/property-value-citations/static-1.3872",
  "react-tinymce": "/react-tinymce/static-1.56380",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8653",
  "rich-text-lib": "/rich-text-lib/static-1.20650",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.622",
  "tiered-pricing": "/tiered-pricing/static-1.2392",
  "tinymce-config": "/tinymce-config/static-2.55506",
  "tinymce-plugins": "/tinymce-plugins/static-1.58620",
  "tinymce-themes": "/tinymce-themes/static-1.57476",
  "topics-actions-lib": "/topics-actions-lib/static-1.734",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1484",
  "trial-components-library": "/trial-components-library/static-1.14487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10404",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11353",
  "laboratory-lib": "/laboratory-lib/static-3.7689",
  "seat-types-lib": "/seat-types-lib/static-1.1178",
  "magpie-lib": "/magpie-lib/static-1.5963",
  "navigation-messaging": "/navigation-messaging/static-1.8659",
  "ts-schema": "/ts-schema/static-1.4433",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11009",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11007",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8732",
  "audio-components": "/audio-components/static-1.6654",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1223",
  "ContentUtils": "/ContentUtils/static-1.69625",
  "copilot-toolkit": "/copilot-toolkit/static-1.12273",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30153",
  "FileManagerImages": "/FileManagerImages/static-1.38093",
  "html-to-image": "/html-to-image/static-1.68",
  "immerable": "/immerable/static-1.4685",
  "ui-universal-auth": "/ui-universal-auth/static-1.9868",
  "urlinator": "/urlinator/static-1.5057",
  "video-components": "/video-components/static-1.14560",
  "video-data-lib": "/video-data-lib/static-1.36216",
  "video-embed": "/video-embed/static-1.37050",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.875",
  "trellis-migration-context": "/trellis-migration-context/static-1.118",
  "event-emitter": "/event-emitter/static-1.1500",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.554",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.713",
  "fast-json-patch": "/fast-json-patch/static-1.77",
  "merchandise-lib": "/merchandise-lib/static-1.291",
  "purchase-motions-components": "/purchase-motions-components/static-1.6724",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13716",
  "reporting-data": "/reporting-data/static-1.69652",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.571",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7125",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19695",
  "onboarding-tours": "/onboarding-tours/static-1.17486",
  "stripe-connect-js": "/stripe-connect-js/static-1.86",
  "chatspot-core": "/chatspot-core/static-1.24292",
  "content-assistance-lib": "/content-assistance-lib/static-1.8507",
  "draft-content-plugins": "/draft-content-plugins/static-1.29258",
  "draft-convert": "/draft-convert/static-2.88",
  "draft-extend": "/draft-extend/static-3.91",
  "draft-js": "/draft-js/static-5.93",
  "draft-plugins": "/draft-plugins/static-2.22454",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2395",
  "poll-commands": "/poll-commands/static-1.4016",
  "video-components-external": "/video-components-external/static-1.12558",
  "trellis-story-utils": "/trellis-story-utils/static-1.5036",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10068",
  "content-media-capture": "/content-media-capture/static-1.5894",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9636",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10827",
  "hub-http-contrib": "/hub-http-contrib/static-1.3570",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5748",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6954",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19668",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4062",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18786",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1553",
  "calling-error-reporting": "/calling-error-reporting/static-1.31870",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11580",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7081",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7653",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2619",
  "commerce-permissions": "/commerce-permissions/static-1.1323",
  "products-iframe-lib": "/products-iframe-lib/static-1.9062",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11391",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6990",
  "sales-views-client-types": "/sales-views-client-types/static-1.4798",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "data-agent-kit": "/data-agent-kit/static-1.1057",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.417",
  "fsm": "/fsm/static-1.4301",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7344",
  "bark-lib": "/bark-lib/static-1.17074",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.109",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6437",
  "react-codemirror": "/react-codemirror/static-1.11182",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5285",
  "tinymce-data": "/tinymce-data/static-1.41591",
  "layout-dnd-components": "/layout-dnd-components/static-1.13323",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12298",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17105",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9407",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16222",
  "hubs-service-types": "/hubs-service-types/static-1.1806",
  "navigation-components": "/navigation-components/static-1.19332",
  "nest": "/nest/static-1.779",
  "nudge-client-utils": "/nudge-client-utils/static-1.3516",
  "purchase-motions-api": "/purchase-motions-api/static-1.6727",
  "signup-constants": "/signup-constants/static-1.20123",
  "idb-keyval": "/idb-keyval/static-1.58",
  "magpie-types": "/magpie-types/static-1.5423",
  "reactive-lib": "/reactive-lib/static-1.1262",
  "simple-logging-lib": "/simple-logging-lib/static-1.3587",
  "nav-meta": "/nav-meta/static-1.30969",
  "breeze-engine-core": "/breeze-engine-core/static-1.1673",
  "cms-field-types": "/cms-field-types/static-1.5353",
  "content-icons-ui": "/content-icons-ui/static-1.2524",
  "integrations-lib": "/integrations-lib/static-1.17567",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.432",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1664",
  "social-insights-client-types": "/social-insights-client-types/static-1.23050",
  "outpost": "/outpost/static-1.4665",
  "persist-promise": "/persist-promise/static-1.4248",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8575",
  "reporting-client-types": "/reporting-client-types/static-1.2903",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11085",
  "immutable-less": "/immutable-less/static-1.5188",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18570",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21163",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8489",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4458",
  "growth-data-modal": "/growth-data-modal/static-1.6222",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3105",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5701",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8208",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29644",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1373",
  "highlight.js": "/highlight.js/static-1.93",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13698",
  "content-media-compositions": "/content-media-compositions/static-2.17705",
  "media-bridge-lib": "/media-bridge-lib/static-1.19734",
  "fix-webm-duration": "/fix-webm-duration/static-1.38",
  "notification-sounds": "/notification-sounds/static-1.4969",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37396",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3896",
  "highcharts": "/highcharts/static-8.118",
  "storybook-react": "/storybook-react/static-1.47",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16778",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69700",
  "layout-data-lib": "/layout-data-lib/static-1.10623",
  "academy-common-lib": "/academy-common-lib/static-1.15683",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3273",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3592",
  "whisper-core-api": "/whisper-core-api/static-1.7746",
  "flux-actions": "/flux-actions/static-1.384",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14982",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6168",
  "redux-observable": "/redux-observable/static-1.82",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4148",
  "oauth-service-types": "/oauth-service-types/static-1.4676",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8691",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1818",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2926",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3133",
  "user-context-client": "/user-context-client/static-1.5047",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15914",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12642",
  "ExportDialog": "/ExportDialog/static-6.10914",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35335",
  "academy-service-client": "/academy-service-client/static-1.4233",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.86",
  "SafeStorage": "/SafeStorage/static-1.4935",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7941",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3560",
  "settings-ui-lib": "/settings-ui-lib/static-1.13072",
  "simple-data-table": "/simple-data-table/static-1.3946",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8159",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15913",
  "simple-menus-lib": "/simple-menus-lib/static-1.17430",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.237",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337"
}
};
